export const PAY_INVOICES_OPENED = "pay_invoices_dialog:opened"
export const PAY_INVOICES_CONFIRMED = "pay_invoices_dialog:confirmed"
export const PAY_INVOICES_CANCELLED = "pay_invoices_dialog:cancelled"
export const CARD_READER_SELECTED = "pay_invoices_dialog:card_reader_selected"
export const CARD_READER_PROCESSED = "pay_invoices_dialog:card_reader_processed"
